import React, { useState } from 'react';
import { addCertificateAPI, addFrameworkAPI } from '../../../apiConfig/apiCall';
import { toast } from 'react-toastify';
import { Button, Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { getCertificationList } from '../../../slices/ManageCompliance/thunk';

export default function AddFrameworkModal({
    addFrameworkModal,
    setAddFrameworkModal,
    toggleAddFrameworkModal,
    refreshComponent
}) {
    const dispatch = useDispatch();

    const [submittingForm, setSubmittingForm] = useState(false);

    const initialFormData = {
        frameworkName: "",
        overview: "",
    };

    const [formData, setFormData] = useState(initialFormData);

    const handleChange = (field, value) => {
        const maxLength = field === "frameworkName" ? 20 : 100;
        if (value.length <= maxLength) {
            setFormData((prevState) => ({
                ...prevState,
                [field]: value,
            }));
        } else {
            toast.error(`Maximum character limit reached for ${field} (${maxLength})`);
        }
    };

    const resetFormFields = () => {
        setFormData(initialFormData);
    };

    const handleSubmitAddFramework = async (e) => {
        e.preventDefault();
        if (submittingForm) return;
        try {
            const { frameworkName, overview } = formData;
            if (!frameworkName) {
                toast.error("Framework Name is required");
                return;
            } else if (frameworkName.length > 20) {
                toast.error("Framework Name must be a maximum of 20 characters");
                return;
            } else if (!overview) {
                toast.error("Overview is required");
                return;
            } else if (overview.length > 100) {
                toast.error("Overview must be a maximum of 100 characters");
                return;
            }

            const dataToSubmit = {
                frameworkName: formData.frameworkName,
                overview: formData.overview,
            };

            setSubmittingForm(true);
            const apiResponse = await addFrameworkAPI(dataToSubmit);
            if (apiResponse.status === 200) {
                refreshComponent();
                toast.success(apiResponse.data);
                resetFormFields();
                setAddFrameworkModal(false);
                dispatch(getCertificationList());
            } else if (apiResponse.status === 400) {
                toast.error(apiResponse.data);
            } else {
                toast.error("Something went wrong");
            }
        } catch (error) {
            console.error('Error sending data:', error);
            toast.error('An error occurred while adding the framework');
        } finally {
            setSubmittingForm(false);
        }
    };

    return (
        <>
            <Modal isOpen={addFrameworkModal} toggle={toggleAddFrameworkModal}>
                <ModalHeader toggle={toggleAddFrameworkModal}>Add Framework</ModalHeader>
                <ModalBody>
                    <Form>
                        <Row className="gy-3">
                            <Col lg={12}>
                                <div>
                                    <Label htmlFor="frameworkName" className="form-label">Framework Name</Label>
                                    <Input
                                        type="text"
                                        className="form-control"
                                        id="frameworkName"
                                        value={formData.frameworkName}
                                        onChange={(e) => handleChange('frameworkName', e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col lg={12}>
                                <div>
                                    <Label htmlFor="overview" className="form-label">Overview</Label>
                                    <Input
                                        type="textarea"
                                        className="form-control"
                                        id="overview"
                                        value={formData.overview}
                                        onChange={(e) => handleChange('overview', e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col lg={12}>
                                {submittingForm ? (
                                    <Button color="primary" className="me-2" type="button" disabled>
                                        <Spinner size="sm"> Loading... </Spinner>
                                    </Button>
                                ) : (
                                    <Button
                                        color="primary"
                                        type="submit"
                                        className="me-2"
                                        disabled={submittingForm}
                                        onClick={handleSubmitAddFramework}
                                    >
                                        Add
                                    </Button>
                                )}
                                <Button
                                    color="secondary"
                                    type="reset"
                                    disabled={submittingForm}
                                    onClick={resetFormFields}
                                >
                                    Reset
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    );
}